import Product from './Product';

class ProductGiftCard extends Product {
  constructor(siteUID, site) {
    super({}, siteUID, site);

    this.badge = { value: null };
    this.brand = { key: site.brandUID, value: 'Mustad Fishing' };
    this.category = '';
    this.images = [
      {
        url: 'https://cdn.shopify.com/s/files/1/3103/9224/products/e38bd83af578077b65a31424bd24d085_grande_93b9e7aa-c2c7-4534-adb8-eb3b2d259514.png?v=1545313446',
      },
    ];
    this.name = {
      value: {
        en: 'Gift Card',
      },
    };
    this.path = 'gift-card';
    this.searchKeys = 'gift card';
    this.series = { value: 'GIFT-CARD' };
    this.sourceId = -1;
    this.subCategory = '';
    this.variableFields = [{ value: 'size', title: 'Value' }];
  }
}

export default ProductGiftCard;
